export const saveSetting = async (setting) => {
    localStorage.setItem("setting", JSON.stringify(setting));
}

export const getSetting = () => {
    return JSON.parse(localStorage.getItem("setting"));
}